// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__u5gg+","footer_link":"Footer_footer_link__44X3r"};